import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CommonSelectListService } from 'src/app/shared/service/common-select-list.service';

@Component({
  selector: 'app-sales-order-print-history',
  templateUrl: './sales-order-print-history.component.html',
  styleUrls: ['./sales-order-print-history.component.css'],
})
export class SalesOrderPrintHistoryComponent implements OnInit {
  @Input() id: number;
  data = [];
  constructor(private service: CommonSelectListService) {}

  ngOnInit() {
    this.getByModuleNameId(this.id);
  }
  getByModuleNameId(id: number) {
    let timeWiseGroupBy = [];
    let fieldWiseGroupBy = [];
    this.service.getByModuleNameAndEntityId(id, 'SalesOrder').subscribe((res) => {
      res.dataList.forEach((ls) => {
        ls.createdOn = moment(ls.createdOn).format('DD-MM-YY h:mm');
        if (ls.value && (ls.keyName == 'selectedDocumentNotes' || ls.keyName == 'selectedDeliveryNote')) {
          ls.value = JSON.parse(ls.value);
          ls.value = ls.value
            .map((type) => {
              return type.name;
            })
            .join(',');
        }
      });
      console.log('res ->', res.dataList);
      this.data = res.dataList;
    });
  }
}
